export class FindOtherApprovedPlanogramsRequest {
  constructor(
    public planogramId: string,
    public stateId: string
  ) {}
}